import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAuthDispatch } from '../../components/AuthProvider'
import ErrorLogs from '../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../components/AuthProvider'
import { clearAllCookies } from './utils'
import { useNavigate } from 'react-router-dom/dist'
const SignOut = () => {
  const { user } = useAuthState()
  const history = useNavigate()
  const { clearSession } = useAuthDispatch()

  React.useEffect(() => {
    clearSession()
    clearAllCookies()
    localStorage.clear()

    history('/', { replace: true })
  }, [clearSession])

  return <h1>Signing out...</h1>
}

export default SignOut
